var render = function render(_c,_vm){return _c('div',{staticClass:"preloader__spinner--btn"})
}
var staticRenderFns = []

export { render, staticRenderFns }